import axios from '@/allotment/axios'

export default {
  tree: () => axios.get('/dic/tree'), //获取字典列表
  save: data => axios.post('/dic/save', data), //保存字典
  status: data => axios.post('/dic/update/status', data), //删除字典
  getChildren: code => axios.get(`/dic/children/${code}`) //获取字典子集列表
}